.cartLink {
  position: relative;
}

.cartCount {
  position: absolute;
  bottom: 4px;
  right: 6px;
  color: var(--colors-text-inverse);
  background-color: var(--colors-primary-main);
  height: 20px;
  width: 20px;
  text-align: center;
  border-radius: 10px;
  line-height: 20px;
}

.bagIcon {
  path {
    /* stylelint-disable-next-line declaration-no-important */
    fill: var(--bloom-colors-header-contrast) !important;
  }
}
